import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  container: {
    paddingTop: "0 !important", // TODO: refactor these styles once .email-container is removed from src/modules/auth/layout/AuthViewContainer.scss
    borderTop: "0 !important",
  },
}));
